"use client";

import { Button } from "./ui/button";
import { useTheme } from "./theme-provider";
import { MoonIcon, SunIcon } from "lucide-react";

export function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();

  const handleThemeToggle = (event: React.MouseEvent<HTMLButtonElement>) => {
    const { clientX: x, clientY: y } = event;
    toggleTheme({ x, y });

    event.preventDefault();
  };

  return (
    <Button variant="outline" size="icon" onClick={handleThemeToggle} className="rounded-full">
      {theme === "dark" ? <SunIcon className="h-5 w-5" /> : <MoonIcon className="h-5 w-5" />}
    </Button>
  );
}
